import { creditAmount } from './format.js';
import { useProjectCredits } from './useProjectCredits.js';

/**
 * THE BALANCE, WHERE AI IS STARTED (S4: "a compact balance next to AI entry
 * points").
 *
 * Only while AI is METERED: before launch there is nothing to spend, and while
 * paused nothing can be started. Nothing while the wallet is loading or could
 * not be read — a balance this chip does not know is left out, never drawn as
 * €0.00, which would read as "you have nothing".
 */
export function CreditBalanceChip({ projectId, testId = 'ai-credits-balance-chip' }: { projectId: string; testId?: string }) {
  const credits = useProjectCredits(projectId);
  const wallet = credits.data;

  if (wallet?.aiBilling !== 'METERED') return null;

  return (
    <span className="chip credits-chip" data-testid={testId} title="Project credits available to spend on AI">
      <span className="credits-chip-label">Project credits</span>
      <span className="credits-chip-value" data-testid={`${testId}-value`}>
        {creditAmount(wallet.availableCents)}
      </span>
    </span>
  );
}
